import { render, staticRenderFns } from "./PaqueteDocumentoForm.vue?vue&type=template&id=95b32c44"
import script from "./PaqueteDocumentoForm.vue?vue&type=script&lang=js"
export * from "./PaqueteDocumentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports